import { render, staticRenderFns } from "./addKeyword.vue?vue&type=template&id=cf43aaaa&scoped=true"
import script from "./addKeyword.vue?vue&type=script&lang=js"
export * from "./addKeyword.vue?vue&type=script&lang=js"
import style0 from "./addKeyword.vue?vue&type=style&index=0&id=cf43aaaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf43aaaa",
  null
  
)

export default component.exports